import { useState } from "react";
import AddUserFormModal from "../forms/admin/AddUserFormModal";
import UserTable from "../forms/admin/userTableAdmin";
import config from '../../config/config';
import ErrorModal from "../ui/ErrorModal";


const AdminUserAdministrationComponent = () => {
  const [showForm, setShowForm] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const downloadUserActivityReport = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${config["backend-url"]}/export_user_activity_by_company`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to download report");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "user_activity_report.csv";
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Error downloading report:", error);
      setErrorMessage("Failed to download report. Please try again.");
      setErrorModalOpen(true);
    }
  };

  return (
    <>
      <div className="dashboard-header">
        <h4 className="welcomeText">User Administration</h4>
        <div style={{display:"flex", gap:"20px"}}>

        <button className="add-request" onClick={() => setShowForm(!showForm)}>
          Add New User
        </button>
        <button className="add-request" onClick={downloadUserActivityReport}>
          Download User Activity
        </button>
        </div>
      </div>

      <AddUserFormModal show={showForm} onClose={() => setShowForm(false)} />
      <UserTable />
      <ErrorModal isOpen={errorModalOpen} message={errorMessage} onClose={() => setErrorModalOpen(false)} />
    </>
  );
};

export default AdminUserAdministrationComponent;
